import React, { forwardRef, type Ref } from 'react';
import { CheckboxGroup as CheckboxGroupNew } from './CheckboxGroup';
import { convertOldCheckboxGroupProps } from './converter.old';
import type { OldCheckboxGroupProps } from './converter.old';
import type { CheckboxGroupInstance } from './CheckboxGroup';

export type CheckboxGroupProps<CheckboxValue> = OldCheckboxGroupProps<CheckboxValue>;

type CheckboxGroupComponent = <CheckboxValue extends string | number | boolean>(
  props: CheckboxGroupProps<CheckboxValue> & { ref?: Ref<CheckboxGroupInstance<CheckboxValue>> },
) => JSX.Element;

function CheckboxGroupInner<CheckboxValue extends string | number | boolean>(
  props: CheckboxGroupProps<CheckboxValue>,
  ref: Ref<CheckboxGroupInstance<CheckboxValue>>,
) {
  return <CheckboxGroupNew {...convertOldCheckboxGroupProps(props)} ref={ref} />;
}

export const CheckboxGroup = forwardRef(CheckboxGroupInner) as CheckboxGroupComponent;
